var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 56,
    viewBox: "0 0 61 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8678 27.4825C41.7409 27.5841 41.6705 27.6075 41.6569 27.5528C40.4204 27.5314 39.184 27.5206 37.9475 27.5206C36.2051 27.5206 34.9706 27.4649 34.244 27.3536C31.4175 26.9219 29.013 25.7509 27.0303 23.8405C22.9654 19.9222 21.7475 15.0144 23.3766 9.11731C23.5641 8.77352 23.7458 8.4102 23.9216 8.02735C25.8408 3.89312 29.3597 1.19459 33.8221 0.204256C34.3592 0.0851027 35.2871 0.0235724 36.6056 0.0196657C42.8757 -0.00182089 49.0795 -0.00572782 55.2169 0.00794549C55.4552 0.00794549 55.5206 0.114402 55.4132 0.327315L41.8678 27.4825Z",
    fill: "#F500F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3766 9.11728C21.7475 15.0144 22.9654 19.9221 27.0303 23.8405C29.0129 25.7509 31.4175 26.9219 34.2439 27.3536C34.9706 27.4649 36.2051 27.5206 37.9474 27.5206C39.1839 27.5206 40.4204 27.5313 41.6568 27.5528L27.9415 55.2325L0.639794 55.2237C0.612958 55.2235 0.586612 55.2165 0.563231 55.2033C0.53985 55.1902 0.520201 55.1713 0.506136 55.1484C0.492072 55.1256 0.484052 55.0995 0.48283 55.0727C0.481608 55.0459 0.487225 55.0192 0.499153 54.9952L23.3766 9.11728Z",
    fill: "#4141F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9414 55.2325L41.6567 27.5529C41.6704 27.6076 41.7407 27.5841 41.8677 27.4825C43.6003 27.4689 45.3143 27.462 47.0098 27.462C48.7737 27.464 50.6167 27.9064 52.5387 28.7893C58.8353 31.6842 61.9059 38.8656 59.8696 45.4815C58.4309 50.149 54.5077 53.8525 49.6468 54.9161C48.6819 55.1271 47.2061 55.2325 45.2196 55.2325C39.5159 55.2306 33.7565 55.2306 27.9414 55.2325Z",
    fill: "#01F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdIcon);
export default __webpack_public_path__ + "static/media/ad-icon.d00ecf39f19bca9d6f4480e62343abb0.svg";
export { ForwardRef as ReactComponent };